import { render, staticRenderFns } from "./VaccineAdd.vue?vue&type=template&id=abc84c0e&scoped=true&"
import script from "./VaccineAdd.vue?vue&type=script&lang=js&"
export * from "./VaccineAdd.vue?vue&type=script&lang=js&"
import style0 from "./VaccineAdd.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abc84c0e",
  null
  
)

export default component.exports